import api from '@/utils/axios';
export async function requestPeopleTags(payload) {
  const response = await api.post('people-tags', payload);
  if (!response.data?.success) throw new Error(response.data?.error?.message || 'Could not load tags.');
  return response.data.data;
}
